module.exports = __webpack_public_path__ + "img/logo_multicereales.addcc89c.png";